import { render, staticRenderFns } from "./extension-plot.vue?vue&type=template&id=8734926c&"
import script from "./extension-plot.vue?vue&type=script&lang=js&"
export * from "./extension-plot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports